import axios from "axios";
const { API_BACKEND_HOST } = process.env;

export const sendFileToSignature = async (minuteId) => {
  const languageId = localStorage.getItem("i18nextLng");

  const response = await axios.post(
    `${API_BACKEND_HOST}${languageId}/v1/Docusign`,
    {
      minuteId,
    }
  );

  return response;
};

export const getDocumentsSentToSignature = async (minuteId) => {
  const languageId = localStorage.getItem("i18nextLng");

  const response = await axios.get(
    `${API_BACKEND_HOST}${languageId}/v1/Docusign/Envelopes`,
    {
      params: {
        minuteId,
      },
    }
  );

  return response;
};


export const getDocumentSignatures = async (idAtaEnvelope) => {
  const languageId = localStorage.getItem("i18nextLng");

  const response = await axios.get(
    `${API_BACKEND_HOST}${languageId}/v1/Docusign/signs`,
    {
      params: {
        idAtaEnvelope,
      },
    }
  );

  return response;
};

export const downloadDocusignDocument = async (docusignEnvelopeId) => {
  const languageId = localStorage.getItem("i18nextLng");

  const response = await axios.get(
    `${API_BACKEND_HOST}${languageId}/v1/Docusign`,
    {
      responseType: "blob",
      params: {
        envelopeId: docusignEnvelopeId,
      },
    }
  );

  const fileURL = window.URL.createObjectURL(new Blob([response.data]));
  const fileLink = document.createElement('a');
  
  fileLink.href = fileURL;
  fileLink.setAttribute('download', 'signed_document.pdf');
  
  document.body.appendChild(fileLink);
  fileLink.click();
  
  document.body.removeChild(fileLink);

  return response;
}